import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rk-input-color-picker',
  templateUrl: './input-color-picker.component.html',
  styleUrls: ['./input-color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputColorPickerComponent),
      multi: true,
    },
  ],
})
export class InputColorPickerComponent implements ControlValueAccessor {
  static sampleColors = [
    '#FF6B81',
    '#FF4757',
    '#FF6348',
    '#FF7F50',
    '#FFA502',
    '#ECCC68',
    '#7BED9F',
    '#2ED573',
    '#70A1FF',
    '#1E90FF',
    '#7023FF',
    '#747D8C',
    '#2F3542',
    '#FFFFFF',
  ];

  @ViewChild('inputRef', { static: true })
  inputRef: ElementRef<HTMLInputElement>;

  @Input()
  disabled: boolean;

  @Input()
  label: string;

  @Input()
  showWhite = true;

  color: string;

  static getRandomColor() {
    // -1 to avoid white
    const sampleLength = InputColorPickerComponent.sampleColors.length - 1;
    const rndIndex = Math.floor(Math.random() * sampleLength);

    return InputColorPickerComponent.sampleColors[rndIndex];
  }

  focusInput() {
    this.inputRef.nativeElement.focus();
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    if (value !== undefined) {
      this.color = value?.toUpperCase();
    }
    this.propagateChange(this.color);
  }

  getColors() {
    return InputColorPickerComponent.sampleColors.filter(color =>
      this.showWhite ? true : color !== '#FFFFFF',
    );
  }
}
